<template>
  <div>
    <div
      class="taskbar"
      :style="{
        border: isLayoutSet ? '1px dashed #2587FF' : '1px solid #d9d9d9',
      }"
    >
      <div class="taskbar_header flex">
        <div class="title">
          <eui-icon icon="eicon-xsrw" color="#333" font-size="18px" />
          <div class="text">销售业务</div>
        </div>
        <el-popover
          ref="popover"
          :offset="-120"
          placement="bottom"
          width="300"
          trigger="click"
          popper-class="taskbar_popover"
        >
          <div>
            <p class="popover_title">快捷显示</p>
            <div class="checkList">
              <div v-for="(item, index) in newList" :key="index" class="checkList_item">
                <el-checkbox v-model="item.checked" :disabled="item.disabled">
                  {{ item.name }}
                </el-checkbox>
              </div>

              <!-- <div class="checkList_item" v-for="(item, index) in newList" :key="index">
                <el-checkbox v-model="item.checked" :disabled="item.disabled">
                  {{ item.name }}
                </el-checkbox>
              </div> -->
            </div>
          </div>
          <div slot="reference" class="date flex">
            <img src="@/assets/img/workbench/taskbar.png" height="16px" alt="" />
          </div>
        </el-popover>
      </div>
      <div class="task_menu flex">
        <div v-for="(item, index) in newList" :key="index">
          <div v-if="item.checked" class="task_item" @click="toPath(item, 1)">
            <div class="task_icon">
              <img :src="item.icon" height="22px" alt="" />
            </div>
            <p>{{ item.name }}</p>
          </div>
        </div>
      </div>
      <div class="task_data flex">
        <div
          v-for="(item, index) in finalData"
          :key="index"
          :class="index + 1 == finalData.length ? 'item_end' : 'data_item'"
        >
          <p class="task_title">

              <eui-icon v-show="item.name === '原材料订单'" icon="eicon-zhongguoshihua"/>
            {{ item.name }}
            <el-tooltip
                    v-show="item.name === '原材料订单'"
                    class="item"
                    effect="dark"
                    placement="top-end"
            >
              <div slot="content">
                  提示：本系统支持产业链全流程追溯功能。<br/>
                  用户可通过石化采购意向单（包括框架协议订货函、中选通知或中标通知）关联相关原材料信息，<br/>
                  实现与易派客平台的原材料采购订单、库存订单及手工录入成品库存等数据的联动查询。<br/>
                  注：特殊材料阀门在技术澄清和签订合同后可根据ERP订单号关联原材料信息。
              </div>
              <i class="el-icon-question"/>
            </el-tooltip>
          </p>
          <div class="flex">
            <div
              v-for="(item1, index1) in item.chidrenData"
              :key="index1"
              class="task_data_item"
              :class="index1 + 1 == item.chidrenData.length ? 'task_data_item_end' : 'task_data_item_box'"
            >
              <div v-show="item1.desc" class="task_desc">{{ item1.desc }}</div>
              <p v-for="(item2, index2) in item1.list" :key="index2" class="task_list">
                <span class="name" :style="{ width: item1.width }">{{ item2.name }}:</span>
                <span :class="item2.count ? 'count' : 'count_none'" @click="toPath(item2, 2)">
                  {{ item2.count > 99 ? '99+' : item2.count }}
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/modules/projectA/api/dataCenter';
import orderApi from '@/modules/projectA/api/order';
import { callBackUrl, purchaseUrl } from '@/modules/projectA/api/config';
import bus from '@/components/common/bus';
import dataBoard from './dataBoard.vue';
import whiteUtils from '../../../../utils/isNanJingWhite';
import api_authority from '@/modules/projectA/api/authority';

export default {
  components: {
    dataBoard,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    isLayoutSet: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      nanJingWhiteData: false,
      newList: [],
      taskMenuList: [
        {
          name: '商品管理',
          icon: require('@/assets/img/workbench/基础信息.png'),
          path: `${callBackUrl}/goodsMaintenance`,
          authCode: '/goodsMaintenance',
          disabled: true,
          checked: true,
        },
        {
          name: '订单管理',
          icon: require('@/assets/img/workbench/预算管理.png'),
          path: `${callBackUrl}/orderManage`,
          authCode: '/orderManage',
          disabled: true,
          checked: true,
        },
        {
          name: '报价管理',
          icon: require('@/assets/img/workbench/需求计划管理.png'),
          path: `${callBackUrl}/havePrice`,
          authCode: '/havePrice',
          disabled: true,
          checked: true,
        },
        {
          name: '销售协议',
          icon: require('@/assets/img/workbench/采购方式.png'),
          path: `${callBackUrl}/scAgreementManage`,
          authCode: '/scAgreementManage',
          checked: true,
        },
        {
          name: '活动管理',
          icon: require('@/assets/img/workbench/询价管理.png'),
          path: `${callBackUrl}/activityNotification`,
          authCode: '/activityNotification',
          disabled: true,
          checked: true,
        },
        /* {
          name: '销售商城',
          icon: require('@/assets/img/workbench/招标管理.png'),
          path: `${bidSysBaseUrl}/#/bidding/preparationScheme`,
          authCode: '/bidding/preparationScheme',
          disabled: true,
          checked: true,
        }, */
      ],
      taskDataList: [
        {
          name: '商品',
          chidrenData: [
            {
              desc: '',
              width: '122px',
              list: [
                {
                  name: '待修改的品牌',
                  count: 0,
                  path: `${callBackUrl}/brandManage`,
                  authCode: '/brandManage',
                },
                {
                  name: '待修改的商品',
                  count: 0,
                  path: `${callBackUrl}/goodsMaintenance`,
                  authCode: '/goodsMaintenance',
                },
                {
                  name: '待修改的规格属性',
                  count: 0,
                  path: `${callBackUrl}/sopspecification`,
                  authCode: '/sopspecification',
                },
              ],
            },
          ],
        },
        {
          name: '订单',
          chidrenData: [
            {
              width: '105px',
              desc: '',
              list: [
                {
                  name: '待确认订单',
                  count: 0,
                  path: `${callBackUrl}/orderManage`,
                  authCode: '/orderManage',
                },
                {
                  name: '待发货订单',
                  count: 0,
                  path: `${callBackUrl}/orderManage`,
                  authCode: '/orderManage',
                },
                {
                  name: '待处理售后申请',
                  count: 0,
                  path: `${callBackUrl}/afterSaleManage`,
                  authCode: '/afterSaleManage',
                },
              ],
            },
          ],
        },
        {
          name: '询价',
          chidrenData: [
            {
              width: '105px',
              desc: '',
              list: [
                {
                  name: '待报价询价单',
                  count: 0,
                  path: `${callBackUrl}/directedInquiry`,
                  authCode: '/directedInquiry',
                },
              ],
            },
          ],
        },
        {
          name: '协议',
          chidrenData: [
            {
              width: '105px',
              desc: '',
              list: [
                {
                  name: '待添加商品协议',
                  count: 0,
                  path: `${callBackUrl}/scAgreementManage`,
                  authCode: '/scAgreementManage',
                },
              ],
            },
          ],
        },
      ],
      menuList: [],
      finalData: [],
      rawMaterialOrderMenu: {
        name: '溯源管理',
        icon: require('@/assets/img/workbench/原材料订单管理.png'),
        path: `${callBackUrl}/rawMaterialOrder/purchasingPlan`,
        authCode: '',
        disabled: true,
        checked: true,
      },
      rawMaterialOrder: {
        name: '原材料订单',
        chidrenData: [
          {
            width: '150px',
            desc: '',
            list: [
              {
                name: '待关联石化采购意向单',
                count: 0,
                path: `${callBackUrl}/rawMaterialOrder/purchasingPlan`,
                authCode: '',
              },
              {
                name: '待关联石化采购订单',
                count: 0,
                path: `${callBackUrl}/rawMaterialOrder/mallOrder`,
                authCode: '',
              },
            ],
          },
        ],
      },
    };
  },
  computed: {
    taskBarMenuList() {
      this.taskMenuList.forEach((item) => {
        if (this.menuList.includes(item.authCode)) {
          item.checked = true;
          item.disabled = false;
        } else {
          item.checked = false;
          item.disabled = true;
        }
      });
      this.newList = [...this.taskMenuList];
      return this.taskMenuList;
    },
    mall_isLogin() {
      return this.$store.state.isLogin;
    },
    /* taskBarDataList() {
      this.taskDataList.forEach(item => {
        let childList = item.chidrenData;
        childList.forEach(list => {
          let childList1 = list.list;
          childList1.forEach(list1 => {
            console.log(this.menuList.includes(list1.authCode), list1.authCode, 'list1.authCode');
            if (this.menuList.includes(list1.authCode)) {
              list1.count = list1.count;
            } else {
              list1.count = 0;
            }
          });
        });
      });
      return this.taskDataList;
    }, */
  },
  watch: {
    mall_isLogin: {
      immediate: true,
      handler(newval) {
        if (newval) {
          const token = this.$cookies.get('epecToken');
          if (token) {
            // this.getPcMenuTree()
            // this.initData();
          }
        }
      },
    },
  },
  async mounted() {
    await this.isNanJingWhite();
    this.initData();
  },
  methods: {
    async isNanJingWhite() {
      const nanJingWhiteData = localStorage.getItem('nanJingWhiteData');

        //判断菜单权限  销售业务中有没有配置原材料订单
        const MENUINFO = JSON.parse(localStorage.getItem('MENUINFO')).childList;

      let saleMarket = MENUINFO.filter(item => item.authId === 12226)[0].childList;
      let rawMaterial = [];

      if (process.env.NODE_ENV === 'production') {
        rawMaterial = saleMarket.filter(item => item.authId === 20212);
      } else {
        rawMaterial = saleMarket.filter(item => item.authId === 12730);
      }

        //两个结合判断
      if (nanJingWhiteData && rawMaterial.length > 0) {
          this.nanJingWhiteData = true;
        } else {
          this.nanJingWhiteData = false;
        }

    },
    getFinalData() {
      const finalList = [];
      this.taskDataList.forEach((item) => {
        const childList = item.chidrenData;
        childList.forEach((list) => {
          const childList1 = list.list;
          childList1.forEach((list1) => {
            if (this.menuList.includes(list1.authCode)) {
              list1.count = list1.count;
            } else {
              list1.count = 0;
            }
          });
        });
      });
      this.finalData = [...this.taskDataList];
    },
    async getStoriesData() {
      const params = {
        companyId: this.$store.state.USERINFO.companyId,
      };

      const res = await Api.queryCompanyStores(params);
      if (res.code == 200) {
        if (res.data?.length > 0) {
          const resObj = res.data[0];
          const { companyId } = this.$store.state.USERINFO;
          const obj = {
            name: '销售商城',
            icon: require('@/assets/img/workbench/销售商城.svg'),
            disabled: false,
            checked: true,
            path: `${purchaseUrl}/brandMall?companyId=${companyId}&columeId=3&shopId=${resObj.temporaryId}`,
          };
          this.sellMall = { ...resObj, ...obj };
          setTimeout(() => {
            this.newList = [...this.taskBarMenuList];
            this.newList.push(this.sellMall);
          }, 500);
        } else {
          this.newList = [...this.taskBarMenuList];
        }
      } else {
        this.sellMall = {};
        this.newList = [...this.taskBarMenuList];
      }
    },
    async getPcMenuTree() {
      const res = await Api.memberMenuTree();


      if (res.code == 200) {
        let menu2 = [];
        if (res.data.purchaseAreaTreeVo.childList) {
          // console.log('qqqqqqqqqqqqqqqqqqqqqqq')
          if (this.nanJingWhiteData) {
            menu2 = res.data.purchaseAreaTreeVo.childList;
          } else {//没配置南京白名单，剔除
            const purchaseAreaTreeVo = whiteUtils.dealNanJingWhite(res.data.purchaseAreaTreeVo);
            menu2 = purchaseAreaTreeVo.childList;
          }
        }

        this.getAuthCode(menu2);
        this.getStoriesData();

        this.getFinalData();
      }
    },
    initData() {
      /* // 品牌
      this.getQuerySupplyCompanyBrandAuditPage();
      // 商品
      this.getQueryReleaseProductByPage();
      // 规格
      this.getQueryAttributeAuditPageByCompany();

      this.getOrderData();
      this.getQueryAgreementForSupplierByPage();
      this.getQuerySupplierOfferCount();
      this.getPcMenuTree(); */
      const list = [
        this.getQuerySupplyCompanyBrandAuditPage(),
        this.getQueryReleaseProductByPage(),
        this.getQueryAttributeAuditPageByCompany(),
        this.getOrderData(),
        this.getQuerySupplierOfferCount(),
        this.getQueryAgreementForSupplierByPage(),
      ];
      Promise.all(list).then((result) => {
        // console.log(result, 'promise all');
        this.taskDataList[0].chidrenData[0].list[0].count = result[0].data?.total || 0; // 品牌
        this.taskDataList[0].chidrenData[0].list[1].count = result[1].data?.total || 0; // 商品
        this.taskDataList[0].chidrenData[0].list[2].count = result[2].data?.total || 0; // 规格
        // 订单
        this.taskDataList[1].chidrenData[0].list[0].count = result[3].data?.waitSupplierConfirmCount || 0;
        this.taskDataList[1].chidrenData[0].list[1].count = result[3].data?.waitSupplierShipCount || 0;
        this.taskDataList[1].chidrenData[0].list[2].count = result[3].data?.waitSupplierAuditAfterSalesCount || 0;

        this.taskDataList[2].chidrenData[0].list[0].count = result[4].data?.waitOfferCount || 0; // 询价

        this.taskDataList[3].chidrenData[0].list[0].count = result[5].data?.total || 0;

        if (this.nanJingWhiteData) {
          this.taskMenuList.push(this.rawMaterialOrderMenu);
          this.countUnLinked();
        }
        // console.log(JSON.parse(JSON.stringify(this.taskDataList)), ' JSON this.taskDataList');
        setTimeout(() => {
          this.getPcMenuTree();
        });
      });
    },
    getAuthCode(list) {
      list.map((item) => {
        if (item.authCode || item.authCode == '') {
          this.menuList.push(item.authCode);
          if (item.childList) {
            this.getAuthCode(item.childList);
          }
        }
      });
    },
    toPath(val, index) {
      if (index == 1) {
        window.open(val.path, '_blank');
      } else if (index == 2) {
        if (val.count) {
          window.open(val.path, '_blank');
        }
      }
    },

    // 待修改的品牌
    async getQuerySupplyCompanyBrandAuditPage() {
      const params = {
        brandAuditStatus: 3,
        pageNum: 1,
        pageSize: 1,
      };
      return Api.querySupplyCompanyBrandAuditPage(params);
      /* const result = await Api.querySupplyCompanyBrandAuditPage(params);
      if (result.code === '200') {
        this.taskDataList[0].chidrenData[0].list[0].count = result.data?.total || 0;
      } */
    },

    // 待修改的商品
    async getQueryReleaseProductByPage() {
      const params = {
        pageNum: 1,
        pageSize: 1,
        systemSign: 0,
        auditStatus: 104,
      };
      return Api.queryReleaseProductByPageData(params);
      /* const result = await Api.queryReleaseProductByPageData(params);
      if (result.code === '200') {
        this.taskDataList[0].chidrenData[0].list[1].count = result.data?.total || 0; // 商品
      } */
    },
    //待关联石化采购意向单 数量
    async countUnLinked() {
      const res = await orderApi.countUnLinked();
      // console.log(res,'resresresresresres')
      if (res.code === '200') {
        if (res.data && Number(res.data) > 99) {
          this.rawMaterialOrder.chidrenData[0].list[0].count = '99+';
        } else {
          this.rawMaterialOrder.chidrenData[0].list[0].count = res.data || 0;
        }
        this.petrolMallOrderUnLinkedNum();
      }
    },
    //石化商城订单-待关联 数量
    async petrolMallOrderUnLinkedNum() {
      const res = await orderApi.petrolMallOrderUnLinkedNum();
      if (res.code === '200') {
        const {data = 0} = res;
        if (data && Number(data) > 99) {
          this.rawMaterialOrder.chidrenData[0].list[1].count = '99+'
        } else {
          this.rawMaterialOrder.chidrenData[0].list[1].count = data || 0;
        }
        this.taskDataList.push(this.rawMaterialOrder);
      }
    },
    // 规格属性数量
    async getQueryAttributeAuditPageByCompany() {
      const params = {
        attributeAuditStatus: '3',
        pageNum: 1,
        pageSize: 1,
      };
      /* const result = await Api.queryAttributeAuditPageByCompany(params);
      if (result.code === '200') {
        this.taskDataList[0].chidrenData[0].list[2].count = result.data?.total || 0;
      } */
      return Api.queryAttributeAuditPageByCompany(params);
    },
    // 获取订单数据
    async getOrderData() {
      /* const result = await Api.supplier({});
      if (result.code === '200') {
        // 待确认订单 waitSupplierConfirmCount;
        // 待发货订单 waitSupplierShipCount
        // 待审核订单 waitSupplierAuditAfterSalesCount;

        this.taskDataList[1].chidrenData[0].list[0].count =
          result.data?.waitSupplierConfirmCount || 0;
        this.taskDataList[1].chidrenData[0].list[1].count = result.data?.waitSupplierShipCount || 0;
        this.taskDataList[1].chidrenData[0].list[2].count =
          result.data?.waitSupplierAuditAfterSalesCount || 0;
      } */
      return Api.supplier({});
    },
    // 询比价数量
    async getQuerySupplierOfferCount() {
      /* const result = await Api.querySupplierOfferCount();
      if (result.code === '200') {
        this.taskDataList[2].chidrenData[0].list[0].count = result.data?.waitOfferCount || 0;
      } */
      return Api.querySupplierOfferCount();
    },
    // 协议数量
    async getQueryAgreementForSupplierByPage() {
      const params = {
        flag: 1,
        externalStatus: 1,
        pageSize: 1,
        pageNum: 1,
      };
      /* const result = await Api.queryAgreementForSupplierByPage(params);
      if (result.code === '200') {
        this.taskDataList[3].chidrenData[0].list[0].count = result.data?.total || 0;
      } */
      return Api.queryAgreementForSupplierByPage(params);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/theme.scss';
.taskbar {
  border: 1px solid #dcdcdc;
  margin-top: 20px;
  background: #fff;
  .taskbar_header {
    height: 44px;
    background: #f5f5f5;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    border-bottom: 1px solid #d9d9d9;
    img {
      cursor: pointer;
    }
    .title {
      font-size: 14px;
      display: flex;
      align-items: center;
      background: #f5f5f5;
      color: #333;
      .text {
        margin-left: 10px;
      }
    }
  }
  .task_menu {
    padding: 20px;
    .task_icon {
      width: 54px;
      height: 54px;
      background: #f5f5f5;
      line-height: 54px;
      text-align: center;
      border-radius: 50%;

      img {
        vertical-align: middle;
      }
    }
    .task_item {
      display: flex;
      flex-flow: column;
      align-items: center;
      cursor: pointer;
      margin-right: 20px;
      p {
        font-size: 14px;
        color: #333333;
        margin-top: 10px;
      }
      p:hover {
        color: $main-col;
      }
    }
  }
  .task_data {
    padding: 20px;
    width: 1008px;
    .task_title {
      font-size: 14px;
      line-height: 14px;
      font-weight: 600;
      color: #333333;
      margin-bottom: 20px;
    }
    .data_item {
      position: relative;
      margin-right: 44px;
    }
    .item_end {
      margin-right: 0px;
    }
    .item_end:after {
      display: none;
    }
    .data_item:after {
      content: '';
      display: inline-block;
      width: 1px;
      background: #dcdcdc;
      height: 100%;
      position: absolute;
      top: 0;
      right: -22px;
    }
    .task_data_item {
      position: relative;
      margin-right: 44px;
      min-width: 110px;
      .task_desc {
        margin-bottom: 20px;
        color: #333333;
        font-size: 14px;
        line-height: 14px;

        text-align: left;
      }
      .task_list {
        margin-bottom: 20px;
        color: #666666;
        font-size: 14px;
        line-height: 14px;
        .name {
          display: inline-block;
          width: 105px;
          text-align: right;
        }
        .count {
          color: $main-col;
          font-weight: 600;
          margin-left: 5px;
          cursor: pointer;
          //width: 22px;
          display: inline-block;
        }
        .count:hover {
          text-decoration: underline;
        }
        .count_none {
          font-weight: 600;
          margin-left: 5px;
          //width: 22px;
          display: inline-block;
        }
      }
    }
    .task_data_item_box:after {
      content: '';
      display: inline-block;
      width: 1px;
      background: #dcdcdc;
      height: 100%;
      position: absolute;
      top: 0;
      right: -22px;
    }
    .task_data_item_end {
      margin-right: 0px;
    }
  }
}
</style>
